var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"shipment-proposals p-5 tw-bg-white border-gray tw-rounded",class:{
    'is-loading': _vm.$wait.is('fetching shipment proposals')
  },attrs:{"id":"proposals-section"}},[(_vm.$wait.is('fetching shipment proposals'))?_c('shipment-proposals-skeleton'):[_c('h4',{staticClass:"mb-5"},[_vm._v(" "+_vm._s(_vm.$t('shipment.titles.proposals'))+" ")]),_c('shipment-proposals-list')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }